import { Modal } from 'react-bootstrap';
import iconClose from 'src/assets/icons/icon-close.svg';
import TherapistAvailabilityWidgetMain from '../TherapistAvailabilityWidget/TherapistAvailabilityWidgetMain';
import './TherapistAvailabilityModal.scss';
import { TherapistAvailabilityWidgetEnum } from '../TherapistAvailabilityWidget/TherapistAvailabilityWidgetEnum';

interface TherapistAvailabilityModalProps {
    showModal: boolean;
    setShowModal: (value: boolean) => void;
    profileId: string | undefined;
}

const TherapistAvailabilityModal = ({
    showModal,
    setShowModal,
    profileId,
}: TherapistAvailabilityModalProps) => {

    return (
        <Modal
            backdrop="static"
            show={showModal}
            dialogClassName="therapist-availability-modal modal-60w modal-60h"
            size="lg"
            centered={true}
        >
            <Modal.Header
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                }}
            >
                <Modal.Title className="d-flex">{TherapistAvailabilityWidgetEnum.headingTextForAvailabilityWidget}</Modal.Title>

                <img className='close-btn' onClick={()=>setShowModal(false)} src={iconClose}
                alt='close modal' />
            </Modal.Header>

            <Modal.Body style={{ backgroundColor: '#f0f2f8' }}>
                <TherapistAvailabilityWidgetMain
                    profileId={profileId && profileId}
                    hideTitle={true}
                />
            </Modal.Body>
        </Modal>
    );
};

export default TherapistAvailabilityModal;
